import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import realtime from './slices/realtimeSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        realtime,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
